import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import CarModels from './view/carmodels/CarModels';
import CarModelDetails from './view/carmodels/CarModelDetails';
import BrokerRates from './view/brokerrates/BrokerRates';
import Desks from './view/desks/Desks';
import Products from './view/products/Products';
import DeskDetails from './view/desks/DeskDetails';
import ProductDetails from './view/products/ProductDetails';
import Items from './view/items/Items';
import ItemDetails from './view/items/ItemDetails';
import BrokerRateDetails from './view/brokerrates/BrokerRateDetails';
import DeskGroups from './view/deskgroups/DeskGroups';
import { UserModel } from '../../api/authentication/authentication.types';
import { AppState } from '../../store/store.types';
import {
  brokerRateEditRoles,
  brokerRateViewRoles,
  carModelEditRoles,
  carModelViewRoles,
  deskEditRoles,
  deskViewRoles,
  itemEditRoles,
  itemViewRoles,
  productEditRoles,
  productViewRoles
} from '../../api/core/core.types';
import ConditionalRoute from '../../components/routes/ConditionalRoute';
import CarModelAuditLog from './view/carmodels/CarModelAuditLog';
import DeskAuditLog from './view/desks/DeskAuditLog';
import DeskOpeningAuditLog from './view/desks/DeskOpeningAuditLog';
import DeskOpeningExceptionAuditLog from './view/desks/DeskOpeningExceptionAuditLog';
import ProductAuditLog from './view/products/ProductAuditLog';
import BrokerRateAuditLog from './view/brokerrates/BrokerRateAuditLog';

interface SetupEntityProps extends RouteComponentProps {
  user: UserModel;
}

class SetupEntity extends React.PureComponent<PropsWithChildren<SetupEntityProps>> {
  render() {
    return (
      <>
        {this.props.children}
        <ConditionalRoute
          acceptedRoles={carModelViewRoles}
          exact
          path={`${this.props.match.path}/carmodels`}
          render={(routeProps) => <CarModels {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={carModelViewRoles}
          exact
          path={`${this.props.match.path}/carmodels/:id/view`}
          render={(routeProps: any) => <CarModelDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={carModelViewRoles}
          exact
          path={`${this.props.match.path}/carmodels/:id/audit`}
          render={(routeProps: any) => <CarModelAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={carModelEditRoles}
          exact
          path={`${this.props.match.path}/carmodels/create`}
          render={(routeProps: any) => <CarModelDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={deskViewRoles}
          exact
          path={`${this.props.match.path}/desks`}
          render={(routeProps) => <Desks {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={deskEditRoles}
          exact
          path={`${this.props.match.path}/desks/create`}
          render={(routeProps: any) => <DeskDetails {...routeProps} isNewCode/>}
        />
        <ConditionalRoute
          acceptedRoles={deskViewRoles}
          exact
          path={`${this.props.match.path}/desks/:code/view`}
          render={(routeProps: any) => <DeskDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={deskViewRoles}
          exact
          path={`${this.props.match.path}/desks/:code/audit`}
          render={(routeProps: any) => <DeskAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={deskViewRoles}
          exact
          path={`${this.props.match.path}/desks/:code/desk-openings/audit`}
          render={(routeProps: any) => <DeskOpeningAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={deskViewRoles}
          exact
          path={`${this.props.match.path}/desks/:code/holidays/audit`}
          render={(routeProps: any) => <DeskOpeningExceptionAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={productViewRoles}
          exact
          path={`${this.props.match.path}/products`}
          render={(routeProps) => <Products {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={productViewRoles}
          exact
          path={`${this.props.match.path}/products/:id/view`}
          render={(routeProps: any) => <ProductDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={productViewRoles}
          exact
          path={`${this.props.match.path}/products/:id/audit`}
          render={(routeProps: any) => <ProductAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={productEditRoles}
          exact
          path={`${this.props.match.path}/products/create`}
          render={(routeProps: any) => <ProductDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={itemViewRoles}
          exact
          path={`${this.props.match.path}/items`}
          render={(routeProps) => <Items {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={itemEditRoles}
          exact
          path={`${this.props.match.path}/items/create`}
          render={(routeProps: any) => <ItemDetails {...routeProps} isNewCode/>}
        />
        <ConditionalRoute
          acceptedRoles={itemViewRoles}
          exact
          path={`${this.props.match.path}/items/:id/view`}
          render={(routeProps: any) => <ItemDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={brokerRateViewRoles}
          exact
          path={`${this.props.match.path}/brokerrates`}
          render={(routeProps) => <BrokerRates {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={brokerRateEditRoles}
          exact
          path={`${this.props.match.path}/brokerrates/create`}
          render={(routeProps: any) => <BrokerRateDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={brokerRateEditRoles}
          exact
          path={`${this.props.match.path}/brokerrates/copy`}
          render={(routeProps: any) => <BrokerRateDetails {...routeProps} isCopy/>}
        />
        <ConditionalRoute
          acceptedRoles={brokerRateViewRoles}
          exact
          path={`${this.props.match.path}/brokerrates/:code/view`}
          render={(routeProps: any) => <BrokerRateDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={brokerRateViewRoles}
          exact
          path={`${this.props.match.path}/brokerrates/:code/audit`}
          render={(routeProps: any) => <BrokerRateAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={deskViewRoles}
          exact
          path={`${this.props.match.path}/deskgroups`}
          render={(routeProps) => <DeskGroups {...routeProps} />}
        />
      </>
    );
  }
}

const subnav = [
  {
    title: 'm2.car_models',
    route: '/setup/carmodels',
    roles: carModelViewRoles
  },
  {
    title: 'm2.desks',
    route: '/setup/desks',
    roles: deskViewRoles
  },
  {
    title: 'm2.desk_groups',
    route: '/setup/deskgroups',
    roles: deskViewRoles
  },
  {
    title: 'm2.products',
    route: '/setup/products',
    roles: productViewRoles
  },
  {
    title: 'm2.broker_rates',
    route: '/setup/brokerrates',
    roles: brokerRateViewRoles
  },
  {
    title: 'm2.items',
    route: '/setup/items',
    roles: itemViewRoles
  }
];

const mapStateToProps = (state: AppState) => ({
  user: state.authentication.user
});

const setupEntity = connect(mapStateToProps, null)(SetupEntity);

export default {
  setupEntity,
  subnav
};
